import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVerticalAlignmentCenter: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconVerticalAlignmentCenter"><Path d="M12 3.5V6.5M12 17.5V20.5M12 10.5V13.5" stroke="currentColor" strokeLinecap="square"/><Path d="M19.5 6.5H4.5V10.5H19.5V6.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M17.5 13.5H6.5V17.5H17.5V13.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconVerticalAlignmentCenter;
